import React from 'react';
import { FormProvider } from '../../context-provider/FormProvider';
import { useArrayContext } from '../context/ArrayContext';
import { ListComponent } from '../ListComponent';
import { CancelButton } from './form-controls/CancelButton';
import { DeleteButton } from './form-controls/DeleteButton';
import { SaveButton } from './form-controls/SaveButton';
import { ResetButton } from './form-controls/ResetButton';

const components = { CancelButton, SaveButton, DeleteButton, ListComponent, ResetButton};

export const ArrayFormProvider = ({ children, ...props }) => {
  const arrayContext = useArrayContext();

  return (
    <FormProvider
      config={arrayContext?.fieldConfig?.arrayOf}
      disabled={!arrayContext?.mode}
      components={components}
      {...props}
    >
      {children}
    </FormProvider>
  );
};
